import { formatPayload } from 'Tracking/utils';
import { BE_GA_DEFAULT_PAYLOAD } from 'Views/booking/constants';
import type { TrackingPayload } from './useTracking';
import { useTracking } from './useTracking';
export const useBETracking = (payload: TrackingPayload = {}) => {
  const options = {
    categoryGA: 'bookingEngine',
  };
  const track = useTracking(formatPayload(payload, options));
  return (p: TrackingPayload) => track({ ...BE_GA_DEFAULT_PAYLOAD, ...formatPayload(p, options) });
};
